import { StyleSheet, Platform } from "react-native";

const fontSize = 14;

const rem025 = fontSize * 0.25;
const rem05 = rem025 * 2;
const rem1 = rem05 * 2;
const rem15 = rem1 * 2;
const rem2 = rem15 * 2;
const rem25 = rem2 * 2;
const rem3 = rem25 * 2;


export const d = StyleSheet.create({
	flex: {
		flex: 1,
	},
	flex2: {
		flex: 2,
	},
	flex3: {
		flex: 3,
	},
});

export const flexDirection = StyleSheet.create({
	row: {
		flexDirection: "row",
	},
	column: {
		flexDirection: "column",
	},
});

export const justifyContent = StyleSheet.create({
	center: {
		justifyContent: "center",
	},
	flexStart: {
		justifyContent: "flex-start",
	},
	flexEnd: {
		justifyContent: "flex-end",
	},
});

export const alignSelf = StyleSheet.create({
	center: {
		alignSelf: "center",
	},
	flexStart: {
		alignSelf: "flex-start",
	},
	flexEnd: {
		alignSelf: "flex-end",
	},
});

export const alignItems = StyleSheet.create({
	center: {
		alignItems: "center",
	},
	stretch: {
		alignItems: "stretch",
	},
	flexEnd: {
		alignItems: "flex-end",
	},
	flexStart: {
		alignItems: "flex-start",
	}

});

export const alignContent = StyleSheet.create({
	spaceAround: {
		alignContent: "space-around",
	},
	spaceBetween: {
		alignContent: "space-between",
	},
});

export const mt = StyleSheet.create({
	auto: {
		marginTop: "auto",
	},
	one: {
		marginTop: rem025,
	},
	two: {
		marginTop: rem05,
	},
	three: {
		marginTop: rem1,
	},
});

export const mb = StyleSheet.create({
	auto: {
		marginBottom: "auto",
	},
	one: {
		marginBottom: rem025,
	},
	two: {
		marginBottom: rem05,
	},
	three: {
		marginBottom: rem1,
	},
});

export const mr = StyleSheet.create({
	auto: {
		marginRight: "auto",
	},
	one: {
		marginRight: rem025,
	},
	two: {
		marginRight: rem05,
	},
	three: {
		marginRight: rem1,
	},
});

export const ml = StyleSheet.create({
	auto: {
		marginLeft: "auto",
	},
	one: {
		marginLeft: rem025,
	},
	two: {
		marginLeft: rem05,
	},
	three: {
		marginLeft: rem1,
	},
});

export const m = StyleSheet.create({
	auto: {
		margin: "auto",
	},
	one: {
		margin: rem025,
	},
	two: {
		margin: rem05,
	},
	three: {
		margin: rem1,
	}
})

export const mx = StyleSheet.create({
	auto: {
		marginLeft: "auto",
		marginRight: "auto",
	},
	one: {
		marginLeft: rem025,
		marginRight: rem025,
	},
	two: {
		marginLeft: rem05,
		marginRight: rem05,
	},
	three: {
		marginLeft: rem1,
		marginRight: rem1,
	}
})

export const my = StyleSheet.create({
	auto: {
		marginTop: "auto",
		marginBottom: "auto",
	},
	one: {
		marginTop: rem025,
		marginBottom: rem025,
	},
	two: {
		marginTop: rem05,
		marginBottom: rem05,
	},
	three: {
		marginTop: rem1,
		marginBottom: rem1,
	}
})

export const p = StyleSheet.create({
	one: {
		padding: rem025,
	},
	two: {
		padding: rem05,
	},
	three: {
		padding: rem1,
	},
})

export const px = StyleSheet.create({
	one: {
		paddingLeft: rem025,
		paddingRight: rem025,
	},
	two: {
		paddingLeft: rem05,
		paddingRight: rem05,
	},
	three: {
		paddingLeft: rem1,
		paddingRight: rem1,

	},
})

export const py = StyleSheet.create({
	one: {
		paddingTop: rem025,
		paddingBottom: rem025,
	},
	two: {
		paddingTop: rem05,
		paddingBottom: rem05,
	},
	three: {
		paddingTop: rem1,
		paddingBottom: rem1,

	},
})

export const pt = StyleSheet.create({
	one: {
		paddingTop: rem025,
	},
	two: {
		paddingTop: rem05,
	},
	three: {
		paddingTop: rem1,
	},
})

export const pb = StyleSheet.create({
	one: {
		paddingBottom: rem025,
	},
	two: {
		paddingBottom: rem05,
	},
	three: {
		paddingBottom: rem1,
	},
})

export const pr = StyleSheet.create({
	one: {
		paddingRight: rem025,
	},
	two: {
		paddingRight: rem05,
	},
	three: {
		paddingRight: rem1,
	},
})

export const pl = StyleSheet.create({
	one: {
		paddingLeft: rem025,
	},
	two: {
		paddingLeft: rem05,
	},
	three: {
		paddingLeft: rem1,
	},
})


export const colors = {
	primary: "rgba(38,166,154,1)",
	primaryLight: "rgba(100,216,203,1)",
	primaryDark: "rgba(0,118,108,1)",
	primaryGlass: "rgba(38,166,154,0.5)",

	red: "rgba(239,83,80,1)",
	redLight: "rgba(255,134,124,1)",
	redDark: "rgba(182,24,39,1)",

	green: "rgba(102,187,106,1)",
	greenLight: "rgba(152,238,153,1)",
	greenDark: "rgba(51,138,62,1)",

	blue: "rgba(66,165,245,1)",
	blueLight: "rgba(128,214,255,1)",
	blueDark: "rgba(0,119,194,1)",

	cyan: "rgba(38,198,218,1)",
	cyanLight: "rgba(111,249,255,1)",
	cyanDark: "rgba(0,149,168,1)",

	pink: "rgba(229,115,115,1)",
	pinkLight: "rgba(255,164,162,1)",
	pinkDark: "rgba(175,68,72,1)",

	gray: "rgba(117,117,117,1)",
	grayLight: "rgba(164,164,164,1)",
	grayDark: "rgba(73,73,73,1)",

	blueGray: "rgba(96,125,139,1)",
	blueGrayLight: "rgba(142,172,187,1)",
	blueGrayDark: "rgba(52,81,94,1)",

	auto: "rgba(123,55,139,1)",
	cool: "rgba(7,84,188,1)",
	fan: "rgba(0,147,11,1)",
	exhaust: "rgba(255,69,13,1)",
	safety: "rgba(239,83,80,1)",
	timer: "rgba(96,125,139,1)",
	timer_set: "rgba(96,125,139,1)",

	default: "#4DB6AC",
	error: "#EF5350"
}

export const fonts = StyleSheet.create({
	body: {
		fontWeight: "300",
		fontSize: 12,
	},
	text: {
		fontWeight: "300",
		fontSize: 14,
		color: "black",
	},
	help: {
		fontWeight: "300",
		fontSize: 14,
		color: colors.grayDark
	},
	header: {
		fontWeight: "300",
		fontSize: 36,
	}
});

export const app = StyleSheet.create({
	backgroundImage: {
		flex: 1,
		flexBasis: "auto",
		height: "100%",
	},
	body: {
		flex: 1,
		...(Platform.OS === "web" ? { maxHeight: 730, minHeight: 730 } : {}),
	},
})



// WEBPACK FOOTER //
// ./src/styles/css.js